import React from "react";
import Link from "components/link";
import { useFilters } from "hooks/useStore";
import { ReactComponent as FilterIcon } from "assets/svgs/filter.svg";
import useAutomaticScroll from "hooks/useScroll";
import useIsSticky from "hooks/useIsSticky";
import clsx from "clsx/lite";

const CollectionMobileNav = ({ links, handle }) => {
	const { toggleSlidePane, collections } = useFilters(["toggleSlidePane", "collections"]);
	const { totalActiveFilters } = handle in collections ? collections[handle] : {};

	useAutomaticScroll(".collection-link[aria-current='page']");

	const isSticky = useIsSticky({ mobileOnly: true });

	return (
		<div className={
			clsx("collection-mobile-nav",
				isSticky && "sticky-element !top-[65px] animate-slideInFromTop",
			)}>
			<div className="overflow-x-auto md:overflow-x-auto sm:mx-auto show-scrollbar mr-2">
				<div className="flex gap-4 justify-between whitespace-nowrap flex-nowrap py-3">
					{links.map((item, index) => (
						<Link
							to={item.url}
							key={index}
							activeClassName="font-bold border-b-2 border-beige"
							className="text-base text-[#414141] collection-link"
						>
							{item.title}
						</Link>
					))}
				</div>
			</div>
			<button onClick={toggleSlidePane} className="bg-lightBeige p-3 relative t-toggle-filters-panel">
				<FilterIcon />
				{totalActiveFilters > 0 && (
					<span className="absolute -top-2 -right-2 bg-beige text-white px-1.5 rounded-full text-xs">
						{totalActiveFilters}
					</span>
				)}
			</button>
		</div>
	);
};

export default CollectionMobileNav;